export const rangeOptions = [
    { value: "Day", label: "Day" },
    { value: "Week", label: "Week" },
    { value: "Month", label: "Month" },
    { value: "Year", label: "Year" },
  ];
  
  export const sentimentScaleDefinition = {
    "-1": "Negative",
    "0": "Neutral",
    "1": "Positive",
  };